import React from "react";
import { useNavigate } from "react-router-dom";

import { getBirthDateAge } from "../../utils/birthDate";
import AthleteSignUpPage from "../../components/auth/AthleteSignUpPage";
import { useAuth } from "../../context/AuthContext";

const AthleteSignupRoute = () => {
  const navigate = useNavigate();
  const { completeAthleteSignup } = useAuth();

  const handleSignUpComplete = (data) => {
    // The signup response carries the created athlete row as `profile`.
    const row = data?.profile;
    if (!row?.id) return;

    const attributes = row.attributes || {};
    const birthDate = row.birth_date || attributes.birth_date || "";
    const guardianEmail = row.guardian_email || attributes.guardian_email || "";
    const age = getBirthDateAge(birthDate);
    const isMinor = age === null || age < 18;

    completeAthleteSignup(row.id, {
      athleteId: row.id,
      isMinor,
      guardianEmail,
    });
    navigate("/athlete/consent", { replace: true });
  };

  return (
    <AthleteSignUpPage
      onSignUpComplete={handleSignUpComplete}
      onGoToLogin={() => navigate("/login")}
      onChangeAccountType={() => navigate("/signup")}
    />
  );
};

export default AthleteSignupRoute;
